import { useMutation } from '@tanstack/react-query';
import axios from 'axios';

import { tpoGenUrls } from 'config/urls';
import { downloadCsv, sendNotification } from 'utils/helperMethods';

import type { ExportPromoLibraryRequest } from '../../types';

const EXPORT_FILE_NAME = 'promo_library_export.csv';
const EXPORT_LIMIT = 10_000;

const exportPromoLibrary = async (body: ExportPromoLibraryRequest): Promise<void> => {
    let token = '';
    try {
        token = localStorage.getItem('accessToken') ?? '';
    } catch {
        // incognito / disabled storage
    }

    const response = await axios(tpoGenUrls.getPromoLibraryExport, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` },
        data: { ...body, limit: EXPORT_LIMIT, offset: 0 },
        responseType: 'blob',
    });

    downloadCsv([response.data], EXPORT_FILE_NAME);
};

const useExportPromoLibraryMutation = () => {
    const { mutate, isPending } = useMutation({
        mutationFn: exportPromoLibrary,
        onSuccess: () => {
            sendNotification('success', 'Export started — your download will begin shortly');
        },
        onError: (error: any) => {
            const message =
                error?.response?.data?.detail ??
                error?.response?.data?.message ??
                error?.message ??
                'Failed to export promo library';
            sendNotification('error', message);
        },
    });

    return { mutate, isPending };
};

export default useExportPromoLibraryMutation;
